<template>
  <div class="match-pair-select-content animate__slideInUp animate__animated animate__faster">
    <div class="scroll">
      <div class="text-right close-icon" @click="closePopup()">
        <i class="fas fa-times" />
      </div>
      <div class="option-title horizontal layout">
        <div class="index" :style="{'background-color': selectedOption.color}">
          {{ selectedOption.index }}
        </div>
        <div class="title flex">
          {{ selectedOption.title }}
        </div>
      </div>
      <div class="match-pair-select-title">
        <div
          class="pair-title-item horizontal layout center"
          v-for="(item, index) in matchPairsOption"
          :key="index"
          @click="selectPair(item, index)"
          :class="{
            'disabled': slide.quizStatus == 5 || isFormSubmitted,
            'correct': slide.quizStatus == 5 && selectedOption.status &&
              selectedOption.status === 'correct',
            'incorrect': slide.quizStatus == 5 && selectedOption.status &&
              selectedOption.status === 'incorrect',
            'selected': (selectedOption.pairSelected && selectedOption.pairSelected.id === item.id),
          }"
        >
          <AhaRadio
            size="lg"
            :checked="selectPairItem == item.id"
            v-if="slide.quizStatus != 5"
          />

          <AhaSvg
            name="correct"
            view-box="0 0 18 18"
            maintain-color
            class="aha-option__icon icon-correct"
            v-if="slide.quizStatus == 5 && selectedOption.id === item.id"
          />
          <AhaSvg
            name="incorrect"
            view-box="0 0 18 18"
            maintain-color
            class="aha-option__icon icon-incorrect"
            v-if="slide.quizStatus == 5 && selectedOption.id !== item.id"
          />
          <div class="flex pair-title-text">
            <AhaKey class="bold" :index="index + 1" />. {{ item.pairTitle }}
          </div>
          <div class="match-pair-selected" v-if="item.pairIndex && slide.quizStatus != 5">
            {{ item.pairIndex }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import AhaRadio from '../common/Radio.vue'
import AhaKey from '../common/Key.vue'

export default {
  components: {
    AhaRadio,
    AhaKey,
  },
  props: {
    selectedOption: {
      type: Object,
      default: () => {},
    },
    matchPairsOption: {
      type: Array,
      default: () => [],
    },
    isFormSubmitted: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectPairItem: null,
    }
  },
  computed: {
    ...mapState({
      slideOptions: (state) => state.slide.SlideOptions,
      slide: (state) => state.slide,
    }),
  },
  methods: {
    selectPair(item, indexPair) {
      if (this.slide.quizStatus == 5 || this.isFormSubmitted) return
      this.selectPairItem = item.id
      const index = this.slideOptions.findIndex((option) => {
        return option.id === this.selectedOption.id
      })
      this.$store.state.slide.SlideOptions.forEach((option) => {
        if (option.pairSelected && option.pairSelected.id === this.selectPairItem) {
          option.pairSelected = null
        }
      })
      this.$store.state.slide.SlideOptions[index].pairSelected = {
        id: item.id,
        pairTitle: item.pairTitle,
        index: indexPair + 1,
      }
      this.closePopup()
      this.$store.dispatch('updateSlide', this.$store.state.slide)
    },
    closePopup() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.close-icon {
  position: absolute;
  top: -28px;
  right: 0px;
  cursor: pointer;
  padding: 6px 10px 5px;
  z-index: 100;
  color: #fff;
  background-color: #000;
  border-radius: 25px;
  font-size: 10px;
  text-transform: uppercase;
}
.match-pair-select-content {
  background-color: #fff;
  width: 100%;
  height: 100%;
  padding: 16px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  max-width: 600px;
  margin: 0 auto;
  z-index: 2;
  position: relative;
  padding-bottom: 0;
  line-height: 1.4;
  color: #333333;
  text-align: left;

  .scroll {
    height: 100%;
    width: 100%;
    overflow-y: auto;
  }
}

.index {
  width: 28px;
  height: 28px;
  border-radius: 28px;
  text-align: center;
  line-height: 28px;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  margin-right: 16px;
}
.title {
  font-size: 14px;
  font-weight: bold;
}
.pair-title-item {
  border: 1px solid #D3D7E1;
  border-radius: 4px;
  margin: 8px 0;
  padding: 10px;
  font-size: 14px;
  line-height: 1.4;
  cursor: pointer;
  &.disabled {
    cursor: not-allowed;
  }

  &.incorrect.selected {
    border: 2px solid #FF4954;
    background-color: rgba(255, 73, 84, 0.5);
  }
  &.correct.selected {
    border: 2px solid #33C173;
    background-color: rgba(51, 193, 115, 0.4);
  }
}
.pair-title-text {
  padding-left: 10px;
}
.option-title {
  margin-top: 8px;
  margin-bottom: 16px;
  align-items: center;
}
.match-pair-selected {
  width: 24px;
  height: 24px;
  text-align: center;
  border-radius: 18px;
  background-color: #EFF1F7;
  font-size: 14px;
  line-height: 24px;
}
</style>
